import { ValidationResult } from 'src/Types/globalTypes'

export const getArrayValidation = (validation: ValidationResult, arrayName: string, index: number, type: string): string | undefined => {
  return validation[`${arrayName}.${index}.${type}`] ? validation[`${arrayName}.${index}.${type}`].message : undefined
}
